import { lazy } from "react";
import { Route } from "react-router-dom";

const UserListPage = lazy(async () =>
    import(
        /* webpackChunkName: "UserListPage" */ "@user/presentation/pages/list/user-list.page"
    ).then((module) => ({ default: module.UserListPage })),
);

export class UserPaths {
    static readonly Root = "user";

    static readonly Create = "create";

    static readonly EditParam = ":userId";
    static readonly Edit = `edit/${UserPaths.EditParam}`;

    static readonly DetailParam = ":userId";
    static readonly Detail = `detail/${UserPaths.DetailParam}`;
}

export class UserRoutes {
    static LIST = `/${UserPaths.Root}`;

    static CREATE = `/${UserPaths.Root}/${UserPaths.Create}`;

    static EDIT = (userId: number): string =>
        `/${UserPaths.Root}/${UserPaths.Edit.replace(
            UserPaths.EditParam,
            userId.toString(),
        )}`;

    static DETAIL = (userId: number): string =>
        `/${UserPaths.Root}/${UserPaths.Detail.replace(
            UserPaths.DetailParam,
            userId.toString(),
        )}`;
}

export const userRoutes = (
    <Route path={UserPaths.Root}>
        <Route
            element={<UserListPage />}
            index
        />
    </Route>
);
